import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lp2-live-class-slides-link',
  template: `
    <lp2-arrow-link
      [isCompact]="isCompact"
      [text]="'studybundle.liveClasses.viewClassSlides' | translate"
      (click)="onClick($event)"
    >
    </lp2-arrow-link>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassSlidesLinkComponent {
  @Input() isCompact: boolean;
  @Output() click = new EventEmitter<PointerEvent>();

  onClick(event: PointerEvent) {
    this.click.emit(event);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-shared/live-class-slides-link/live-class-slides-link.component.ts